import React, { useEffect, useRef } from 'react';

// Textarea whose height always matches its content (no internal scrollbar).
// Wheel events inside the textarea are prevented from bubbling so that a
// wrapping scrollable container (e.g. a kanban column) doesn't scroll while
// the user is editing the note.
interface Props {
  value: string;
  onChange: (v: string) => void;
  onBlur?: (v: string) => void;
  placeholder?: string;
  style?: React.CSSProperties;
  minHeight?: number;
  rows?: number;
  onClick?: (e: React.MouseEvent<HTMLTextAreaElement>) => void;
}

export default function AutoSizingTextarea({
  value, onChange, onBlur, placeholder, style, minHeight = 72, rows = 3, onClick,
}: Props) {
  const ref = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    const ta = ref.current;
    if (!ta) return;
    ta.style.height = 'auto';
    ta.style.height = ta.scrollHeight + 'px';
  }, [value]);

  return (
    <textarea
      ref={ref}
      value={value}
      onChange={e => onChange(e.target.value)}
      onBlur={e => onBlur?.(e.target.value)}
      onClick={onClick}
      placeholder={placeholder}
      rows={rows}
      style={{
        width: '100%',
        minHeight,
        overflow: 'hidden',
        resize: 'none',
        fontSize: 13,
        color: 'var(--ink)',
        lineHeight: 1.6,
        fontFamily: 'var(--font-ui)',
        ...style,
      }}
    />
  );
}
